<template>
  <div class="w-full h-full  overflow-hidden" :class="data.layout === 'BannerLong' ? 'flex' : ''">
    <el-image
      v-for="(item, index) in bannerList"
      :key="index"
      :class="['flex', 'items-center', 'justify-center']"
      :style="{
        width: `calc(100% / ${
          bannerList.length > 1 && data.layout === 'BannerLong' ? bannerList.length : 1
        })`,
        height: `calc(100% / ${
          bannerList.length > 1 && data.layout === 'BannerShort' ? bannerList.length : 1
        } )`,
      }"
      :src="`${fileUrl}${item.imageFile}`"
      :fit="data.imageFit || 'fill'"
      @click="toDetail(item)"
    >
      <!-- <span class="w-8/10 truncate text-center text-hex-e2182d text-48px">{{ item.title }}</span> -->
    </el-image>
  </div>
</template>
<script>
import { ColumnTableApi } from '@wiz-api/workbench'
import addRequestQueue from '@/assets/js/RequestQueue'

const columnTableApi = new ColumnTableApi()
export default {
  name: 'bannerLong',
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
    mode: {
      type: String,
      default: '',
    },
  },
  computed: {
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(val, oldVal) {
        if (!_.isEmpty(val)) {
          if (!_.isEmpty(val.dataSource) && val.dataSource !== oldVal?.dataSource) {
            this.getCompentData(val)
          }
        }
      },
    },
  },
  data() {
    return {
      bannerList: [],
    }
  },
  methods: {
    async toDetail(row) {
      if (this.mode === 'update') {
        return
      }
      if (row.jumpType === 2) {
        row.skipMode === 1 ? window.open(row.url) : (window.location.href = row.url)
      } else if (row.jumpType === 1) {
        const path = `${this.routerBase}/portal/homepage?columnId=${row.jumpColumn}`
        // row.skipMode === 1
        //   ? window.open(`${window.location.origin}${window.location.hash ? '/#' : ''}${path}`)
        //   : this.$router.push(path)
        window.open(`${window.location.origin}${window.location.hash ? '/#' : ''}${path}`)
      }
    },
    async getCompentData(obj) {
      const [err, res] = await addRequestQueue(() => {
        return columnTableApi.getBinnerColumnTable(1, obj.pageSize ? obj.pageSize : 1, {
          columnId: obj.dataSource,
          isShow: true,
        })
      })
      if (!err && res) {
        this.bannerList = []
        _.map(res.items, (it) => {
          it.isShow === true ? this.bannerList.push(it) : ''
        })
      }
    },
    filterHeight() {
      let str = ''
      if (this.data.layout === 'BannerLong') {
        this.bannerList.length > 1
          ? (str = `w-[calc(100%/${this.bannerList.length})] h-full`)
          : (str = 'w-full h-full')
      } else {
        this.bannerList.length > 1
          ? (str = `h-[calc(100%/${this.bannerList.length})] w-full`)
          : (str = 'w-full h-full')
      }
      return str
    },
  },
}
</script>

<style lang="scss" scoped></style>
